import React from 'react';
import { useAppSelector } from 'hooks/redux';
import { Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export interface MapLegendModalProps {
  open: boolean;
  handleClose: () => void;
}
const smallLegWidth = 450;
const largeLegWidth = 600;
const smallLegHeight = 150;
const largeLegHeight = 200;

export const MapLegendModal: React.FC<MapLegendModalProps> = ({
  open,
  handleClose,
}) => {
  const { currenLegendtUrl, legendSize } = useAppSelector(
    (state) => state.layers
  );
  const _width = legendSize === 'large' ? largeLegWidth : smallLegWidth;
  const _height = legendSize === 'large' ? largeLegHeight : smallLegHeight;

  const width = window.screen.width > 768 ? _width : '60vw';
  const height = window.screen.width > 768 ? _height : '20vw';

  return open ? (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        zIndex: 1000,
        borderRadius: '2px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'end',
          alignItems: 'center',
        }}
      >
        <IconButton onClick={handleClose} sx={{ p: 0 }}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box sx={{ overflow: 'auto' }}>
        <img
          id="legend-ref"
          src={currenLegendtUrl}
          alt="legeng"
          style={{ width: width, height: height }}
        />
      </Box>
    </Box>
  ) : null;
};
